// Utility function to wait for an element to appear in the DOM
const waitForElement = (selector, timeout = 5000, interval = 100) => {
  return new Promise((resolve) => {
    const startTime = Date.now();

    const checkElement = () => {
      const element = document.querySelector(selector);

      if (element) {
        resolve(element);
      } else if (Date.now() - startTime >= timeout) {
        console.warn(`Element ${selector} not found after ${timeout}ms`);
        resolve(null);
      } else {
        setTimeout(checkElement, interval);
      }
    };

    checkElement();
  });
};

document.addEventListener("DOMContentLoaded", function () {
  const tradeSelectorInput = document.querySelector(".js-trade-input");
  const { journeyName } = document.querySelector("body").dataset;

  const body = document.querySelector("body");
  const generalContractorModal = document.querySelector(
    ".general-contractor-modal",
  );

  const disableBodyScrolling = () =>
    body.classList.add("general-contractor-modal-open");

  const enableBodyScrolling = () =>
    body.classList.remove("general-contractor-modal-open");

  function clearTrade() {
    const element = $(".js-ai-trade-search-wrapper");
    if (element.length > 0) {
      element.find(".js-ai-change").click();
      element.find(".js-ai-trade-search").val("");
      element.find(".js-ai-trade-search").trigger("change");
      element.find(".ai-results").hide();
    } else {
      const tradeInput = $(".trade-search-input");
      tradeInput.val("");
      tradeInput.trigger("input");
      $(".js-change").click();
    }
  }

  async function setHandypersonTrade() {
    const element = $(".js-ai-trade-search-wrapper");
    const trade = "Handyperson";

    if (element.length > 0) {
      element.find(".js-trade-input").val(trade);
      element.find(".js-trade-input").trigger("change");
      element.find(".answer").text(trade);
      element.parent().removeClass("state-search").addClass("state-selected");
      element.find(".ai-search-input-wrapper").hide();
    } else {
      // Legacy trade selector path
      $(".js-change").click();

      const tradeInput = await waitForElement(".trade-search-input", 5000);

      if (!tradeInput) {
        console.error("Trade search input not found after clicking Change");
        return;
      }

      $(tradeInput).val(trade);
      $(tradeInput).trigger("input");

      const handypersonOption = await waitForElement(
        'li[data-value="Handyperson"]',
        5000
      );

      if (handypersonOption) {
        handypersonOption.click();
      } else {
        console.error("Handyperson option not found in legacy trade selector");
        // Fallback: directly set the hidden input value
        const $tradeInput = $(".js-trade-input");
        if ($tradeInput.length > 0) {
          $tradeInput.val(trade);
          $tradeInput.trigger("change");
        }
      }
    }
  }

  document
    .querySelectorAll(".js-general-contractor-modal-no")
    .forEach((elem) => {
      elem.addEventListener("click", (e) => {
        e.preventDefault();

        if (tradeSelectorInput) {
          // Set suppression flag BEFORE changing the value
          // This prevents duplicate tracking events from firing
          $(tradeSelectorInput).attr("data-suppress-auto-tracking", "true");
        }

        setHandypersonTrade().then(() => {
          generalContractorModal.classList.add("hide-modal");
          generalContractorModal.classList.remove("fade-in", "show-modal");

          // Mark the trade input as confirmed via modal and trigger the event
          if (window.EventTracker && tradeSelectorInput) {
            const $input = $(tradeSelectorInput);

            // Remove suppression flag and add modal flag
            $input.removeAttr("data-suppress-auto-tracking");

            // Add data attribute to indicate modal confirmation
            $input.attr("data-from-modal", "true");

            window.EventTracker.trigger(
              "primary_detail_selected", // event name
              $input,
              false, // fromViewAllTradeList (this can never be `true` from General contractor modal)
              $input.data("search-id") || null, // search_id (currently a single search id will be shared for both "General contractor" and "Handyperson" if chosen from modal)
              null, // redirectedFromVertical
              "simplybusiness_us", // business_unit (we can hard code this as this modal is only for US)
              null, // selected_location (this will be set to null for now, and updated in a subsequent ticket to a non-null value)
              null, // selectedIndex (this is set to null in the General contractor modal, as the metric does not apply)
              false // isTradePrefilled
            );

            // Clean up the data attribute
            $input.removeAttr("data-from-modal");
          }
        });

        enableBodyScrolling();
      });
    });

  document
    .querySelectorAll(".js-general-contractor-modal-select-another-trade")
    .forEach((elem) => {
      elem.addEventListener("click", (e) => {
        e.preventDefault();

        generalContractorModal.classList.add("hide-modal");
        generalContractorModal.classList.remove("fade-in", "show-modal");
        enableBodyScrolling();

        clearTrade();
      });
    });

  document
    .querySelectorAll(".js-general-contractor-modal-yes")
    .forEach((element) => {
      element.addEventListener("click", (e) => {
        e.preventDefault();
        // Mark the trade input as confirmed via modal and trigger the event
        if (window.EventTracker && tradeSelectorInput) {
          const $input = $(tradeSelectorInput);

          // Add data attribute to indicate modal confirmation
          $input.attr("data-from-modal", "true");

          window.EventTracker.trigger(
            "primary_detail_selected", // event name
            $input,
            false, // fromViewAllTradeList (this can never be `true` from General contractor modal)
            $input.data("search-id") || null, // search_id (currently a single search id will be shared for both "General contractor" and "Handyperson" if chosen from modal)
            null, // redirectedFromVertical
            "simplybusiness_us", // business_unit (we can hard code this as this modal is only for US)
            null, // selected_location (this will be set to null for now, and updated in a subsequent ticket to a non-null value)
            null, // selectedIndex (this is set to null in the General contractor modal, as the metric does not apply)
            false // isTradePrefilled
          );

          // Clean up the data attribute
          $input.removeAttr("data-from-modal");
        }

        generalContractorModal.classList.add("hide-modal");
        generalContractorModal.classList.remove("fade-in", "show-modal");
        enableBodyScrolling();
      });
    });

  async function fadeInGCModal() {
    const delay = (milliseconds) => {
      return new Promise((resolve) => {
        setTimeout(resolve, milliseconds);
      });
    };

    await delay(50);

    generalContractorModal.classList.add("show-modal");

    await delay(50);
    disableBodyScrolling();
    generalContractorModal.classList.remove("hide-modal");
    generalContractorModal.classList.add("fade-in");
  }

  const userComingFromCoverageSelectionPage = document.referrer.includes(
    "/coverage_selection/",
  );

  // We have this code for when a trade is prefilled, e.g. from selecting General Contractor from /trades?vertical=usa'
  if (
    tradeSelectorInput &&
    journeyName === "coverage_selection" &&
    tradeSelectorInput.value === "General contractor" &&
    // e.g. don't show modal if user clicking back from next coverage selection page
    !userComingFromCoverageSelectionPage
  ) {
    fadeInGCModal();
  }

  if (tradeSelectorInput) {
    $(tradeSelectorInput).on("change", (e) => {
      if (e.target.value === "General contractor") {
        fadeInGCModal();
      }
    });
  }
});
